import { supabase } from '../supabaseClient'

// Las credenciales del rival de un partido de la red (Edge Function credenciales-rival, spec
// 2026-10-15 §4). `juegoId` es el id del partido en el club (juegos.id). `invoke` marca error en
// cualquier status distinto de 2xx, pero el cuerpo trae el motivo ('sin_permiso', ...): sin
// leerlo, "no tienes acceso" y "se cayo el servidor" se verian igual.
export const getCredencialesRival = async (juegoId) => {
  const { data, error } = await supabase.functions.invoke('credenciales-rival', { body: { juego_id: juegoId } })
  if (error) {
    let code = null
    try { code = (await error.context?.json())?.error } catch { /* cuerpo no legible */ }
    return { data: null, error, code: code || 'error' }
  }
  return { data, error: null, code: null }
}
